import { MagnifyingGlass } from '@phosphor-icons/react';
import { ClipLoader } from 'react-spinners';
import { useScreenView } from '../../../../../../utils/ScreenViewContext';

type SearchThisAreaButtonProps = {
  onClick: () => void;
  isSearching: boolean;
  isPreActive: boolean;
};

const BASE_CLASSES =
  'absolute left-1/2 z-40 flex -translate-x-1/2 flex-row items-center justify-center space-x-2 rounded-[4px] border-[1px] border-[#1D213B] bg-white px-4 py-2 text-[#1D213B] shadow-lg hover:cursor-pointer hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60';

// On phones the map header occupies the top 140px, so this sits just below it,
// level with the recenter control. Elsewhere it sits low over the map.
const MOBILE_CLASSES = 'top-[150px]';
const DEFAULT_CLASSES = 'bottom-24';

export default function SearchThisAreaButton({
  onClick,
  isSearching,
  isPreActive,
}: SearchThisAreaButtonProps) {
  const { screenView } = useScreenView();

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isSearching || isPreActive}
      aria-label="Search this area"
      title={
        isPreActive
          ? 'Complete onboarding to search other areas'
          : 'Search this area'
      }
      className={`${BASE_CLASSES} ${
        screenView === 'mobile' ? MOBILE_CLASSES : DEFAULT_CLASSES
      }`}
    >
      {isSearching ? (
        <ClipLoader color="#1D213B" size={16} loading />
      ) : (
        <MagnifyingGlass size={16} />
      )}
      <span className="whitespace-nowrap text-sm font-medium">
        Search this area
      </span>
    </button>
  );
}
